// extracted by mini-css-extract-plugin
export default {"button":"AmountButtonTableOrder_button__pwN71","container":"AmountButtonTableOrder_container__yk6Wg"};